const initialState = {
  agent: null,
  queues: null,
  scope: null,
  groups: null,
  callFlows: null,
  supervisedAgentIds: null,
  agentIds: null,
  presences: null,
  presencesProfile:null,
  supervisedAgentDetails:null,
  language: null,
 
};
export const dataReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_AGENT_PROFILE":
      return { ...state, agent: action.payload };
    case "SET_QUEUES":
      return { ...state, queues: action.payload };
    case "SET_SCOPE":
      return { ...state, scope: action.payload };
    case "SET_GROUPS":
      return { ...state, groups: action.payload };
    case "SET_CALL_FLOWS":
      return { ...state, callFlows: action.payload };
    case "SET_SUPERVISED_AGENT_IDS":
      return { ...state, supervisedAgentIds: action.payload };
    case "SET_AGENT_IDS":
      return { ...state, agentIds: action.payload };
    case "SET_AGENT_PRESENCES": 
      return {...state,presences: action.payload };
      case "SET_MY_AGENT_PROFILE_PRESENCES": 
      return {...state,presencesProfile: action.payload };
      case "SET_SUPERVISED_AGENT_DATA":
      return {...state,supervisedAgentDetails: action.payload };
      case 'SET_LANGUAGE':
      return { ...state,language: action.payload};
    default:
      return state;
  }
};
